import { Box } from '../../Box';
import { Spinner } from '../../Spinner';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveSize = size => {
  const map = {
    small: 16,
    sm: 16,
    default: 20,
    medium: 20,
    md: 20,
    aux: 16,
    large: 24,
    lg: 24
  };
  return map[size || 'medium'];
};
const loadingButtonStyle = (theme, buttonStyle) => ({
  top: '0',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  height: '100%',
  width: '100%',
  backgroundColor: buttonStyle === 'primary' ? theme.tokens.SemColorSurfaceMuted : theme.tokens.SemColorSurfaceDefault,
  cursor: 'not-allowed',
  outline: 'auto'
});
export const LoadingButtonOverlay = props => {
  const theme = useInterstateTheme();
  const {
    size,
    buttonStyle
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    sx: loadingButtonStyle(theme, buttonStyle),
    children: /*#__PURE__*/_jsx(Spinner, {
      size: resolveSize(size)
    })
  });
};